/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { css } from '@fluentui/react';

const DEFAULT_CELL_STYLE_PROPS = {
  cellLeftPadding: 12,
  cellRightPadding: 8,
  cellExtraRightPadding: 24,
};

const getCellText = (item, column) => {
  let value = item && column && column.fieldName ? item[column.fieldName] : '';

  if (value === null || value === undefined) {
    value = '';
  }

  if (typeof value === 'boolean') {
    return value.toString();
  }

  return value;
};

export const RowFieldsWithFreeze = (props) => {
  const {
    columns,
    columnStartIndex,
    rowClassNames,
    cellStyleProps = DEFAULT_CELL_STYLE_PROPS,
    item,
    itemIndex,
    onRenderItemColumn,
    getCellValueKey,
    cellsByColumn,
    enableUpdateAnimations,
    rowHeaderId,
    freezingCount = 0,
    freezingRTLCount = 0,
    selectionMode = 0,
  } = props;

  const cellValueKeysRef = React.useRef();

  const cellValueKeys = cellValueKeysRef.current || (cellValueKeysRef.current = {});

  function renderCell(column, columnIndex) {
    const width =
          typeof column.calculatedWidth === 'undefined'
            ? 'auto'
            : column.calculatedWidth +
              cellStyleProps.cellLeftPadding +
              cellStyleProps.cellRightPadding +
              (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);

    const { onRender = onRenderItemColumn, getValueKey = getCellValueKey } = column;
    const cellContentsRender =
          cellsByColumn && column.key in cellsByColumn
            ? cellsByColumn[column.key]
            : onRender
              ? onRender(item, itemIndex, column)
              : getCellText(item, column);

    const previousValueKey = cellValueKeys[column.key];

    const cellValueKey = enableUpdateAnimations && getValueKey ? getValueKey(item, itemIndex, column) : undefined;

    let showAnimation = false;

    if (cellValueKey !== undefined && previousValueKey !== undefined && cellValueKey !== previousValueKey) {
      showAnimation = true;
    }

    cellValueKeys[column.key] = cellValueKey;

    // generate a key that auto-dirties when content changes, to force the container to re-render,
    // to trigger animation
    const key = `${column.key}${cellValueKey !== undefined ? `-${cellValueKey}` : ''}`;
    return (
      <div
        key={key}
        id={column.isRowHeader ? rowHeaderId : undefined}
        role={column.isRowHeader ? 'rowheader' : 'gridcell'}
        aria-readonly
        aria-colindex={columnIndex + columnStartIndex + 1}
        className={css(
              column.className,
              column.isMultiline && rowClassNames.isMultiline,
              column.isRowHeader && rowClassNames.isRowHeader,
              rowClassNames.cell,
              column.isPadded ? rowClassNames.cellPadded : rowClassNames.cellUnpadded,
              showAnimation && rowClassNames.cellAnimation
            )}
        style={{ width }}
        data-automationid="DetailsRowCell"
        data-automation-key={column.key}
      >
        {cellContentsRender}
      </div>
    );
  }

  const freezingColumns = columns.slice(0, freezingCount);
  const otherColumns = columns.slice(freezingCount, columns.length - freezingRTLCount);
  const frezzingColumnsRTL = columns.slice(columns.length - freezingRTLCount);

  return (
    <div className={rowClassNames.fields} data-automationid="DetailsRowFields" role="presentation">
      {freezingColumns.length > 0 && <div className={`freeze-columns-group ${selectionMode ? 'has-checkbox' : ''}`}>{freezingColumns.map(renderCell)}</div>}
      <div className="other-columns-group">{otherColumns.map(renderCell)}</div>
      {frezzingColumnsRTL.length > 0 && <div className="freeze-columns-group right">{frezzingColumnsRTL.map(renderCell)}</div>}
    </div>
  );
};
